import { siteInfo } from '@/mocks/home';

export default function HeroSection() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center pt-[72px] overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-background-50 to-background-100"></div>
      <div className="absolute top-0 right-0 w-[60%] h-full opacity-[0.06]">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle at 30% 40%, oklch(var(--primary-500) / 0.6) 0%, transparent 50%), radial-gradient(circle at 70% 60%, oklch(var(--accent-500) / 0.5) 0%, transparent 50%)',
        }}></div>
      </div>

      <div className="relative w-full px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/15 border border-primary-500/25 mb-5">
              <span className="w-2 h-2 rounded-full bg-primary-500 animate-pulse"></span>
              <span className="text-xs font-medium text-primary-400 whitespace-nowrap">每日同步更新 · 高清流畅不缓冲</span>
            </div>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-foreground-100 leading-tight">
              桃花视频
              <br className="hidden sm:block" />
              <span className="text-primary-400">热门影视一网打尽</span>
            </h1>

            <p className="text-sm md:text-base text-foreground-400 leading-relaxed mt-4 max-w-lg mx-auto lg:mx-0">
              {siteInfo.description}
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mt-6">
              {siteInfo.stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-xl md:text-2xl font-bold text-primary-400">{stat.value}</div>
                  <div className="text-xs text-foreground-500 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 mt-7">
              <a
                href="#cards"
                onClick={(e) => handleNavClick(e, '#cards')}
                className="w-full sm:w-auto px-8 py-3 rounded-lg bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm transition-colors text-center whitespace-nowrap cursor-pointer"
              >
                立即追剧
                <i className="ri-arrow-right-line ml-2"></i>
              </a>
              <a
                href="#ranking"
                onClick={(e) => handleNavClick(e, '#ranking')}
                className="w-full sm:w-auto px-8 py-3 rounded-lg border border-background-300/60 hover:border-primary-500/50 text-foreground-300 hover:text-foreground-100 font-medium text-sm transition-colors text-center whitespace-nowrap cursor-pointer"
              >
                热门榜单
                <i className="ri-fire-line ml-2"></i>
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[500px] lg:max-w-none">
            <div className="relative aspect-[4/3] rounded-2xl overflow-hidden bg-background-200/50 border border-background-200/40">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20collage%20with%20popular%20Chinese%20dramas%20and%20films%2C%20golden%20warm%20lighting%2C%20dramatic%20composition%2C%20floating%20film%20strips%20and%20stars%2C%20elegant%20dark%20background%20with%20crimson%20accents%2C%20professional%20art%20design&width=800&height=600&seq=hero-main&orientation=landscape"
                alt="桃花视频热门影视精选合集"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-950/50 via-transparent to-transparent"></div>
              <div className="absolute bottom-4 left-4 right-4 flex items-center gap-2">
                <div className="w-2 h-2 rounded-full bg-primary-500 animate-pulse"></div>
                <span className="text-xs text-foreground-200 font-medium">猎罪图鉴2 · 热播中</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}